export const TOKEN = "token"
export const HEADER_TOKEN = "Authorization"
export const USER = "user_info"
export const NO_LOGIN_KEY = "no_login_key"
export const SPEECH_TOKEN = 'SPEECH_TOKEN'

/**
 * 格式化 token
 * @param token 
 * @returns 
 */
export const formatToken = (token: string) => {
    return `Bearer ${token}`
}